module.exports = __webpack_public_path__ + "static/img/pic2.dd8694f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case2/pic2.jpg
// module id = oZnn
// module chunks = 1